import { terminalCalculation } from "hooks/terminalSolution/terminalSolutionMappers";

export const amountToBeBilledCalculation = terminalList => {
	const terminalCalculations = terminalList?.map(terminalData => {
		const { terminal, quantity } = terminalData || {};
		const {
			terminal_accessories,
			month_rental_price,
			equipment_insurance,
			shipping_and_handling,
			estimated_tax,
			price_per_terminal,
		} = terminal || {};

		let totalPrice = terminalCalculation({
			terminal: {
				pricePerTerminal: price_per_terminal,
				monthRentalPrice: month_rental_price,
				equipmentInsurance: equipment_insurance,
				shippingAndHandling: shipping_and_handling,
				estimatedTax: estimated_tax,
				terminalConfigurationOption:
					terminal?.terminal_configuration_option,
				quantity: quantity,
			},
			terminalAccessories: terminal_accessories,
		});
		return totalPrice;
	});

	return terminalCalculations.reduce((acc, val) => {
		return acc + val;
	}, 0);
};
